import React, { useState } from 'react';
import { 
  Dialog, 
  DialogContent, 
  DialogHeader, 
  DialogTitle, 
  DialogFooter 
} from './ui/dialog';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { useToast } from '../hooks/use-toast';
import { User } from 'lucide-react';

const SetLoginModal = ({ employee, authHeader, onClose, onLoginSet }) => {
  const [login, setLogin] = useState(employee.login || '');
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate login
    if (!login || login.length < 3) {
      toast({
        title: "Помилка",
        description: "Логин повинен містити мінімум 3 символи",
        variant: "destructive",
      });
      return;
    }
    
    if (login.length > 50) {
      toast({
        title: "Помилка",
        description: "Логин повинен містити максимум 50 символів",
        variant: "destructive",
      });
      return;
    }
    
    setLoading(true);
    
    try {
      const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
      
      const apiUrl = BACKEND_URL ? `${BACKEND_URL}/api/employees/${employee.id}/set-login` : `/api/employees/${employee.id}/set-login`;
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authHeader
        },
        body: JSON.stringify({ login })
      });
      
      const data = await response.json();
      
      if (response.ok) {
        toast({
          title: "Успіх",
          description: `Логин для ${employee.name} успішно встановлено`,
          variant: "default",
        });
        
        // Notify parent component
        if (onLoginSet) {
          onLoginSet(employee.id, login);
        }
        
        // Close modal
        if (onClose) {
          onClose();
        }
      } else {
        toast({
          title: "Помилка",
          description: data.error || "Не вдалося встановити логин",
          variant: "destructive",
        });
      }
    } catch (error) {
      console.error('Error setting login:', error);
      toast({
        title: "Помилка",
        description: "Не вдалося встановити логин",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={!!employee} onOpenChange={(open) => {
      if (!open && onClose) {
        onClose();
      }
    }}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center space-x-2">
            <User className="w-5 h-5" />
            <span>Встановити логин</span>
          </DialogTitle>
        </DialogHeader>
        
        {employee && (
          <div className="py-2">
            <p className="text-sm text-gray-600 mb-4">
              Встановлення логина для: <strong>{employee.name}</strong>
            </p>
            
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <label htmlFor="login" className="text-sm font-medium text-gray-700">
                  Логин
                </label>
                <Input
                  id="login"
                  type="text"
                  value={login}
                  onChange={(e) => setLogin(e.target.value)}
                  placeholder="Введіть логин для співробітника"
                  required
                />
                {employee.login && (
                  <p className="text-xs text-gray-500">
                    Поточний логин: {employee.login}
                  </p>
                )}
              </div>
              
              <DialogFooter className="flex space-x-2">
                <Button type="button" variant="outline" onClick={onClose} disabled={loading}>
                  Скасувати
                </Button>
                <Button type="submit" disabled={loading}>
                  {loading ? 'Встановлення...' : 'Встановити логин'}
                </Button>
              </DialogFooter>
            </form>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default SetLoginModal;